import Vue from 'vue'
import formatDate from '@/helpers/format_date'

export default {
  setAnalyticsFilters(state, value) {
    state.analyticsFilters = value
  },
  setAnalyticsList(state, value) {
    state.analyticsList = value
  },
  unshiftAnalyticsList(state, value) {
    for (let i = 0; i < state.analyticsList.length; i++) {
      if (state.analyticsList[i].owner_type === value.owner_type) {
        state.analyticsList.splice(i, 0, value)
        break
      }
    }
  },
  setAnalyticsReport(state, value) {
    console.log('state.analyticsReport', value)
    state.analyticsReport = value
  },
  changeAnalyticsReport(state, payload) {
    for (let i = 0; i < state.analyticsList.length; i++) {
      if (state.analyticsList[i].id === payload.key) {
        state.analyticsList.splice(i, 1, payload.value)
        break
      }
    }
  },
  deleteAnalyticsReport(state, id) {
    for (let i = 0; i < state.analyticsList.length; i++) {
      if (state.analyticsList[i].id === id) {
        state.analyticsList.splice(i, 1)
        break
      }
    }
  },
  setAnalyticsReportField(state, obj) {
    if (state.analyticsReport) {
      state.analyticsReport = { ...state.analyticsReport, ...obj }
    }
  },
  setAnalyticsReportSetting(state, obj) {
    if (state.analyticsReport) {
      state.analyticsReport['settings'] = {
        ...state.analyticsReport['settings'],
        ...obj,
      }
      console.log("state.analyticsReport['settings']", state.analyticsReport['settings'])
    }
  },
  setAnalyticsData(state, value) {
    state.analyticsData = value

    const list = []
    let title = ''
    let group = ''
    _.each(value, item => {
      if (item.group.id !== group) {
        group = item.group.id
        title = item.group.title

        list.push({
          divider: true,
        })
        list.push({
          header: title,
          group_id: group,
        })
      }

      list.push({
        id: item.id,
        alias: item.alias,
        title: item.title,
        description: item.description,
        group: title,
        group_id: group,
      })
    })

    state.dataList = list
  },
  setAnalyticsDataGraph(state, data) {
    if (!data.graph) {
      state.analyticsDataGraph = null
    } else {
      const labels = _.map(data.graph.labels, item => {
        return isNaN(item) ? item : formatDate(item, `dateString.${data.group}`, `dateNumber.${data.group}`)
      })

      const datasets = _.map(data.graph.datasets, (item, index) => {
        return {
          borderColor: Vue.config.analyticColors[index],
          backgroundColor: Vue.config.analyticColors[index],
          label: item.label,
          data: Object.values(item.data),
        }
      })

      state.analyticsDataGraph = {
        labels: labels,
        datasets: datasets,
      }
    }
  },
  setAnalyticsDataViewWithoutHeader(state, value) {
    state.analyticsDataView = value
  },
  setAnalyticsDataView(state, value) {
    state.analyticsDataView = value

    // TODO: Вынести в отдельную мутацию
    state.tableHeaders = []

    let dataItem = []
    if (state.analyticsReport.settings) {
      const settings = state.analyticsReport.settings

      _.each(state.analyticsData, item => {
        if (item.id === settings.data_id) dataItem = item
      })

      const firstKey = Object.keys(dataItem.ordered_fields).shift()

      dataItem.ordered_fields.forEach(item => {
        state.tableHeaders.push({
          text: item.value,
          align: 'left',
          // todo: set correct names on backend
          // align: 'cfip'.includes(key.charAt(0)) ? 'right' : 'left',
          sortable: true,
          orderBy: item.order,
          key: item.key,
          // todo: add custom width
          width: item.key === firstKey ? '300px' : item.key.charAt(0) !== 's' ? '200px' : '400px',
        })
      })

      state.tableHeaders.sort((a, b) => a.orderBy - b.orderBy)
    }
  },
  updateAnalyticsDataView(state, value) {
    state.analyticsDataView = state.analyticsDataView.concat(value)
  },
  setAnalyticsDataSum(state, value) {
    console.log('value', value)
    state.analyticsDataSum = value
  },
  setReportInfo(state, value) {
    state.reportInfo = value
  },
  setAnalyticsFormatName(state, value) {
    state.analyticsFormatName = value
  },
  setDetailsList(state, value) {
    state.detailsList = value
  },
  setFiltersList(state, value) {
    const list = []

    _.each(value, group => {
      list.push({
        header: group.title,
      })
      _.each(group.list, item => {
        list.push({
          id: `${group.id}-${item.id}`,
          title: item.title,
          group: group.title,
        })
      })
      list.push({
        divider: true,
      })
    })

    state.filtersList = list
  },
  setDates(state, obj) {
    state.dates = { ...state.dates, ...obj }
  },
  setAnalyticsFillStudios(state, value) {
    state.analyticsFillStudios = value
  },
}
